module.exports = __webpack_public_path__ + "media/goodChoice.ee95c508.mp3";